import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-travel-wage-menu',
    templateUrl: './travel-wage-menu.component.html',
    styleUrls: ['./travel-wage-menu.component.css']
})
export class TravelWageMenuComponent implements OnInit {

    private travelWageId: string = '';
    
    public menu: TravelWageMenuGetInterface | undefined;

    public deleting = false;

    constructor(private datatask: DataTaskService, private state: StateService, private modal: ModalService) {
        this.travelWageId = state.getStateParams()['travelwage_id'];
    }

    private async loadMenu() {
        this.menu = (await this.datatask.Post(1491, { travelwage_id: this.travelWageId }))[0];
    };

    public async deleteValues() {
        if (!this.menu) return;

        try {
            const handleDelete = await this.modal.openConfirmDialog({
                type: 'danger',
                title: 'confirm_title',
                translateTitle: true,
                message: 'confirm_message',
                translateMessage: true,
            });

            if (!handleDelete) return;

            this.deleting = true;
            const response = (await this.datatask.Post(1493, this.menu))[0];

            if (response?.errorcode !== '0') {
                this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response.errormessage,
                });
            } else {
                this.state.back();
            }
        } catch(err) {
            console.error(err);
        } finally {
            this.deleting = false;
        }
    }

    ngOnInit(): void {
        this.loadMenu();
    }
}

interface TravelWageMenuGetInterface {
    travelwage_id: string;
    travelwage_name: string;
    glyphicon: string;
}
